var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircularlining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 652,
    height: 985,
    viewBox: "0 0 652 985",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4468_2196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M492.66 983.469C763.903 983.469 983.789 763.583 983.789 492.34C983.789 221.097 763.903 1.21136 492.66 1.21136C221.417 1.21136 1.53125 221.097 1.53125 492.34C1.53125 763.583 221.417 983.469 492.66 983.469Z",
    stroke: "#F4F4F4",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.662 955.115C748.245 955.115 955.437 747.924 955.437 492.34C955.437 236.756 748.245 29.5649 492.662 29.5649C237.078 29.5649 29.8867 236.756 29.8867 492.34C29.8867 747.924 237.078 955.115 492.662 955.115Z",
    stroke: "#F4F4F4",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.66 926.753C732.579 926.753 927.073 732.26 927.073 492.34C927.073 252.42 732.579 57.9266 492.66 57.9266C252.74 57.9266 58.2461 252.42 58.2461 492.34C58.2461 732.26 252.74 926.753 492.66 926.753Z",
    stroke: "#F4F4F4",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.661 898.4C716.922 898.4 898.721 716.601 898.721 492.34C898.721 268.079 716.922 86.2802 492.661 86.2802C268.401 86.2802 86.6016 268.079 86.6016 492.34C86.6016 716.601 268.401 898.4 492.661 898.4Z",
    stroke: "#F4F4F4",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.659 870.038C701.256 870.038 870.357 700.937 870.357 492.34C870.357 283.743 701.256 114.642 492.659 114.642C284.062 114.642 114.961 283.743 114.961 492.34C114.961 700.937 284.062 870.038 492.659 870.038Z",
    stroke: "#F4F4F4",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.661 841.685C685.599 841.685 842.005 685.278 842.005 492.34C842.005 299.402 685.599 142.996 492.661 142.996C299.723 142.996 143.316 299.402 143.316 492.34C143.316 685.278 299.723 841.685 492.661 841.685Z",
    stroke: "#F4F4F4",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.659 813.331C669.937 813.331 813.65 669.618 813.65 492.34C813.65 315.062 669.937 171.349 492.659 171.349C315.38 171.349 171.668 315.062 171.668 492.34C171.668 669.618 315.38 813.331 492.659 813.331Z",
    stroke: "#F4F4F4",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.66 784.969C654.275 784.969 785.29 653.955 785.29 492.34C785.29 330.725 654.275 199.711 492.66 199.711C331.046 199.711 200.031 330.725 200.031 492.34C200.031 653.955 331.046 784.969 492.66 784.969Z",
    stroke: "#F4F4F4",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.658 756.616C638.614 756.616 756.934 638.295 756.934 492.34C756.934 346.385 638.614 228.064 492.658 228.064C346.703 228.064 228.383 346.385 228.383 492.34C228.383 638.295 346.703 756.616 492.658 756.616Z",
    stroke: "#F4F4F4",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.66 728.262C622.956 728.262 728.582 622.636 728.582 492.34C728.582 362.044 622.956 256.418 492.66 256.418C362.364 256.418 256.738 362.044 256.738 492.34C256.738 622.636 362.364 728.262 492.66 728.262Z",
    stroke: "#F4F4F4",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.662 699.9C607.294 699.9 700.222 606.972 700.222 492.34C700.222 377.708 607.294 284.78 492.662 284.78C378.029 284.78 285.102 377.708 285.102 492.34C285.102 606.972 378.029 699.9 492.662 699.9Z",
    stroke: "#F4F4F4",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.66 671.547C591.633 671.547 671.867 591.313 671.867 492.34C671.867 393.367 591.633 313.133 492.66 313.133C393.687 313.133 313.453 393.367 313.453 492.34C313.453 591.313 393.687 671.547 492.66 671.547Z",
    stroke: "#F4F4F4",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.661 643.185C575.971 643.185 643.507 575.649 643.507 492.34C643.507 409.031 575.971 341.495 492.661 341.495C409.352 341.495 341.816 409.031 341.816 492.34C341.816 575.649 409.352 643.185 492.661 643.185Z",
    stroke: "#F4F4F4",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.659 614.832C560.31 614.832 615.151 559.99 615.151 492.34C615.151 424.69 560.31 369.849 492.659 369.849C425.009 369.849 370.168 424.69 370.168 492.34C370.168 559.99 425.009 614.832 492.659 614.832Z",
    stroke: "#F4F4F4",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.661 586.478C544.652 586.478 586.799 544.331 586.799 492.34C586.799 440.349 544.652 398.202 492.661 398.202C440.67 398.202 398.523 440.349 398.523 492.34C398.523 544.331 440.67 586.478 492.661 586.478Z",
    stroke: "#F4F4F4",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.659 558.116C528.986 558.116 558.435 528.667 558.435 492.34C558.435 456.013 528.986 426.564 492.659 426.564C456.332 426.564 426.883 456.013 426.883 492.34C426.883 528.667 456.332 558.116 492.659 558.116Z",
    stroke: "#F4F4F4",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.661 529.763C513.329 529.763 530.083 513.008 530.083 492.34C530.083 471.672 513.329 454.918 492.661 454.918C471.993 454.918 455.238 471.672 455.238 492.34C455.238 513.008 471.993 529.763 492.661 529.763Z",
    stroke: "#F4F4F4",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4468_2196"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 984.68,
    height: 984.68,
    fill: "white",
    transform: "translate(0.320312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularlining);
export default __webpack_public_path__ + "static/media/circular lining.40ca829dbeb88bcdcc22c4ce0b349f3d.svg";
export { ForwardRef as ReactComponent };